
import React from "react";

export const LoadingState: React.FC = () => {
  return (
    <div className="container py-12">
      <div className="flex justify-center">
        <div className="w-8 h-8 border-4 border-primary border-t-transparent rounded-full animate-spin"></div>
      </div>
    </div>
  );
};
